import { render, staticRenderFns } from "./forming_type.vue?vue&type=template&id=3462a5e4&scoped=true"
import script from "./forming_type.vue?vue&type=script&lang=js"
export * from "./forming_type.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3462a5e4",
  null
  
)

export default component.exports